import { NgModule } from '@angular/core';
import { RestrictInputDirective } from './directive/restrict-input-directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import {
    MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatFormFieldModule,
} from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { AuthModule } from 'viewbid-shared-lib';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import { CreateProfileHomePageComponent } from './pages/create-profile-home-page/create-profile-home-page.component';
import { PostalCodeDirective } from './directive/postal-code.directive';
import { FullNameDirective } from './directive/full-name.directive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpTranslateLoader } from '../../../http-translate-loader';
import { HttpClient } from '@angular/common/http';
import { ProfilesRoutingModule } from './profiles-routing.module';
import { CreateAddressSectionComponent } from './components/create-address-section/create-address-section.component';
import { CreateUserProfileComponent } from './components/create-user-profile/create-user-profile.component';
import { CreateBusinessProfileComponent } from './components/create-business-profile/create-business-profile.component';
import { CreateCharityProfileComponent } from './components/create-charity-profile/create-charity-profile.component';
import { MatDialogModule } from '@angular/material/dialog';
import { StoreModule } from '@ngrx/store';
import { createProfileFeature } from './state/create-profile-state';
import { EffectsModule } from '@ngrx/effects';
import { CreateNotificationPreferencesComponent } from './components/create-notification-preferences/create-notification-preferences.component';
import { RegistrationConfirmationPageComponent } from './pages/registration-confirmation-page/registration-confirmation-page.component';
import { SharedModule } from '../../shared/shared.module';
import { AuctionsModule } from '../auctions/auctions.module';
import { WatchlistPageComponent } from './pages/watchlist-page/watchlist-page.component';
import {
    watchlistPageFeatureKey,
    watchlistReducer,
} from './state/watchlist-page-state/watchlist-page-state.reducer';
import { UserProfilePageComponent } from './pages/user-profile-page/user-profile-page.component';
import { UserBidsComponent } from './components/user-bids/user-bids.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import {
    userBidHistoryFeatureKey,
    userBidHistoryReducer,
} from './state/bidding/user-bid-history.reducer';
import { MatMenuModule } from '@angular/material/menu';
import { UserAddressesComponent } from './components/user-addresses/user-addresses.component';
import { UserAddressesFormComponent } from './components/user-addresses-form/user-addresses-form.component';
import { UserInvoicesComponent } from './components/user-invoices/user-invoices.component';
import { UserAppointmentsComponent } from './components/user-appointments/user-appointments.component';
import { InvoiceActionsPageComponent } from './pages/invoice-actions-page/invoice-actions-page.component';
import { UserInformationComponent } from './components/user-information/user-information.component';
import { ViewInvoicePageComponent } from './pages/view-invoice-page/view-invoice-page.component';
import { UserPaymentInformationComponent } from './components/user-payment-information/user-payment-information.component';
import { AddPaymentInformationFormComponent } from './components/add-payment-information-form/add-payment-information-form.component';
import { ExpiryFormatPipe } from 'src/app/expiry-format.pipe';
import { UserNotificationsRemindersComponent } from './components/user-notifications-reminders/user-notifications-reminders.component';
import { PaymentCardListItemComponent } from './components/payment-card-list-item/payment-card-list-item.component';
import { AddressSelectionComponent } from './components/address-selection/address-selection.component';
import { PickupCalendarComponent } from './components/pickup-calendar/pickup-calendar.component';
import { PersonNameDirective } from './directive/person-name.directive';
import { EmailValidatorDirective } from './directive/email-validator.directive';
import { PickupTimeSlotsComponent } from './components/pickup-time-slots/pickup-time-slots.component';
import { InvoicePaymentsComponent } from './components/invoice-payments/invoice-payments.component';
import { NumberOnlyDirective } from './directive/number-only.directive';
import { WatchlistPageStateEffects } from './state/watchlist-page-state/watchlist-page-state.effects';
import { UserMessagesComponent } from './components/user-messages/user-messages.component';
import { MessageThreadComponent } from './components/user-messages/message-thread/message-thread.component';
import { UserPurchaseOffersComponent } from './components/user-purchase-offers/user-purchase-offers.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { UserNotificationsComponent } from './components/user-notifications/user-notifications.component';
import { UserNewsletterComponent } from './components/user-newsletter/user-newsletter.component';
import { NotificationPreferenceComponent } from './components/notification-preference/notification-preference.component';
import { InvoiceOrderConfirmComponent } from './pages/invoice-actions-page/components/invoice-order-confirm/invoice-order-confirm.component';
import { InvoiceSummaryComponent } from './pages/invoice-actions-page/components/invoice-summary/invoice-summary.component';
import { InvoiceDeliveryOptionsComponent } from './pages/invoice-actions-page/components/invoice-delivery-options/invoice-delivery-options.component';
import { InvoiceFulfillmentDetailsComponent } from './pages/invoice-actions-page/components/invoice-fulfillment-details/invoice-fulfillment-details.component';
import { InvoicePaymentComponent } from './pages/invoice-actions-page/components/invoice-payment/invoice-payment.component';
import { InvoiceConfirmationComponent } from './pages/invoice-actions-page/components/invoice-confirmation/invoice-confirmation.component';
import { VerifyPhoneNumberComponent } from './components/verify-phone-number/verify-phone-number.component';
import { DeviceCheckService } from '../../shared/services/device-check.service';
import {
    VbAddressCardComponent,
    VbAppointmentTableComponent,
    VbAvatarComponent,
    VbBannerComponent,
    VbBidTableComponent,
    VbBreadcrumbComponent,
    VbButtonComponent,
    VbCheckboxComponent,
    VbChipComponent,
    VbLotFilterModalComponent,
    VbIconButtonComponent,
    VbIconComponent,
    VbInvoiceTableComponent,
    VbLegendComponent,
    VbMessageTableComponent,
    VbOptionRowComponent,
    VbPaginatorComponent,
    VbPanelHeaderComponent,
    VbPaymentMethodRowComponent,
    VbPaymentTableComponent,
    VbPrefRowComponent,
    VbSearchInputComponent,
    VbSegmentedComponent,
    VbSelectComponent,
    VbSidebarComponent,
    VbStatCardComponent,
    VbStepSectionComponent,
    VbToggleComponent,
    VbSpinnerComponent,
} from '@viewbid/ui';

@NgModule({
    imports: [
        StoreModule.forFeature(createProfileFeature),
        StoreModule.forFeature(watchlistPageFeatureKey, watchlistReducer),
        StoreModule.forFeature(userBidHistoryFeatureKey, userBidHistoryReducer),
        EffectsModule.forFeature([WatchlistPageStateEffects]),
        SharedModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatStepperModule,
        MatDialogModule,
        MatSnackBarModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ProfilesRoutingModule,
        AuctionsModule,
        MatMenuModule,
        AuthModule,
        PopoverModule.forRoot(),
        VbLotFilterModalComponent,
        // --- profile redesign (standalone @viewbid/ui components) ---
        VbAddressCardComponent,
        VbAppointmentTableComponent,
        VbAvatarComponent,
        VbBannerComponent,
        VbBidTableComponent,
        VbBreadcrumbComponent,
        VbButtonComponent,
        VbCheckboxComponent,
        VbChipComponent,
        VbIconButtonComponent,
        VbIconComponent,
        VbInvoiceTableComponent,
        VbLegendComponent,
        VbMessageTableComponent,
        VbOptionRowComponent,
        VbPaginatorComponent,
        VbPanelHeaderComponent,
        VbPaymentMethodRowComponent,
        VbPaymentTableComponent,
        VbPrefRowComponent,
        VbSearchInputComponent,
        VbSegmentedComponent,
        VbSelectComponent,
        VbSidebarComponent,
        VbStatCardComponent,
        VbStepSectionComponent,
        VbToggleComponent,
        VbSpinnerComponent,
    ],
    declarations: [
        CreateProfileHomePageComponent,
        CreateAddressSectionComponent,
        RestrictInputDirective,
        PostalCodeDirective,
        FullNameDirective,
        CreateUserProfileComponent,
        CreateBusinessProfileComponent,
        CreateCharityProfileComponent,
        CreateNotificationPreferencesComponent,
        RegistrationConfirmationPageComponent,
        WatchlistPageComponent,
        UserProfilePageComponent,
        UserBidsComponent,
        UserProfileComponent,
        UserAddressesComponent,
        UserAddressesFormComponent,
        UserInvoicesComponent,
        UserAppointmentsComponent,
        InvoiceActionsPageComponent,
        UserInformationComponent,
        ViewInvoicePageComponent,
        UserPaymentInformationComponent,
        AddPaymentInformationFormComponent,
        ExpiryFormatPipe,
        UserNotificationsRemindersComponent,
        PaymentCardListItemComponent,
        AddressSelectionComponent,
        PickupCalendarComponent,
        PersonNameDirective,
        EmailValidatorDirective,
        PickupTimeSlotsComponent,
        InvoicePaymentsComponent,
        NumberOnlyDirective,
        UserMessagesComponent,
        MessageThreadComponent,
        UserPurchaseOffersComponent,
        UserNotificationsComponent,
        UserNewsletterComponent,
        NotificationPreferenceComponent,
        InvoiceOrderConfirmComponent,
        InvoiceSummaryComponent,
        InvoiceDeliveryOptionsComponent,
        InvoiceFulfillmentDetailsComponent,
        InvoicePaymentComponent,
        InvoiceConfirmationComponent,
        VerifyPhoneNumberComponent,
    ],
    exports: [
        CreateProfileHomePageComponent,
        CreateAddressSectionComponent,
        WatchlistPageComponent,
        ExpiryFormatPipe,
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                floatLabel: 'always',
                displayDefaultIndicatorType: false,
            },
        },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: {
                showError: false,
                displayDefaultIndicatorType: true,
            },
        },
        {
            provide: 'window',
            useFactory: (): any => {
                return window;
            },
        },
        DeviceCheckService,
    ],
})
export class ProfilesModule {}
